import { Injectable } from '@nestjs/common'
import { TipoMensajeModel } from '../models/tipo-mensaje.model'

export const PLATAFORMAS = {
  facebook: 1,
  whatsapp: 2,
  instagram: 3,
}

@Injectable()
export class WebhookTipoMensajeService {
  async obtenerTipoMensaje(plataforma: 'facebook' | 'whatsapp' | 'instagram'): Promise<TipoMensajeModel[]> {
    return await TipoMensajeModel.findAll({
      attributes: ['configuracion', 'nombre', 'id'],
      where: {
        eliminado: 0,
        plataformaId: PLATAFORMAS[plataforma], //TODO: cambiar el nombre de la base de datos
      },
    })
  }
  // async obtener(aplicacionId: number) {
  //   return await WebhookTipoMensajeModel.findAll({
  //     where: {
  //       eliminado: 0,
  //       aplicacionId,
  //     },
  //   })
  // }
}
